<div class="auth-page">
  <div class="auth-card auth-card--with-back">
    <a class="auth-back-button" [routerLink]="backLink">
      <i class="bi bi-arrow-left"></i>
      Back
    </a>
    <div class="auth-card-inner">
      <div class="auth-visual">
        <p class="auth-visual-kicker">Appstrax</p>
        @if (authStep != null && !isEditMode) {
          <ol class="auth-step-indicator" aria-label="Setup progress">
            @for (s of setupSteps; track s) {
              <li [class.is-active]="authStep >= s"></li>
            }
          </ol>
        }
        <h1 class="auth-visual-title">
          {{ isEditMode ? 'Edit Project' : 'Create Project' }}
        </h1>
        <p class="auth-visual-subtitle">
          {{ isEditMode ? 'make your changes' : 'to get started' }}
        </p>
        @if (logoPreviewUrl) {
          <div class="logo-preview">
            <img [src]="logoPreviewUrl" alt="Logo preview" />
          </div>
        }
        <div class="auth-visual-deco" aria-hidden="true"></div>
      </div>

      <div class="auth-form">
        <h2 class="auth-form-title">Welcome!</h2>
        <p class="auth-form-lead">
          {{ isEditMode ? 'Edit your project' : 'Create your project' }}
        </p>

        <form (ngSubmit)="createProject()" #form="ngForm" autocomplete="off">
          <div class="form-group">
            <div class="org-dropdown" [class.show]="isOrgMenuOpen">
              <button
                type="button"
                class="btn btn-outline-dark dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                (click)="toggleOrgMenu()"
                [attr.aria-expanded]="isOrgMenuOpen"
              >
                <span class="d-flex align-items-center gap-2">
                  @if (organization.logoUrl) {
                    <img [src]="organization.logoUrl" alt="logo" class="org-thumb" />
                  } @else {
                    <i class="bi bi-briefcase org-thumb-fallback"></i>
                  }
                  <span>{{ organization.id ? organization.name : '* Select Organization' }}</span>
                </span>
                <i class="bi bi-chevron-down"></i>
              </button>
              <ul
                class="dropdown-menu dropdown-menu-end w-100"
                [class.show]="isOrgMenuOpen"
                [attr.data-bs-popper]="isOrgMenuOpen ? 'static' : null"
              >
                @for (org of organizations; track org) {
                  <li>
                    <button
                      class="dropdown-item d-flex align-items-center gap-2"
                      type="button"
                      (click)="selectOrganization(org)"
                    >
                      @if (org.logoUrl) {
                        <img [src]="org.logoUrl" alt="logo" class="org-thumb" />
                      } @else {
                        <i class="bi bi-briefcase org-thumb-fallback"></i>
                      }
                      <span>{{ org.name }}</span>
                    </button>
                  </li>
                }
              </ul>
            </div>
          </div>
          <div class="form-group">
            <label for="name" class="visually-hidden">Project Name</label>
            <div class="input-with-icon">
              <i class="bi bi-building"></i>
              <input
                type="text"
                class="form-control"
                id="name"
                name="name"
                [(ngModel)]="project.name"
                placeholder="* Project Name"
                required
              />
            </div>
          </div>
          <div class="form-group">
            <label for="description" class="visually-hidden">Project Description</label>
            <div class="input-with-icon">
              <i class="bi bi-file-earmark-text"></i>
              <input
                type="text"
                class="form-control"
                id="description"
                name="description"
                [(ngModel)]="project.description"
                placeholder="* Project Description"
                required
              />
            </div>
          </div>
          <button type="button" class="btn btn-outline-secondary mb-4" (click)="logoFileInput.click()">
            <i class="bi bi-image me-2"></i>
            Choose Logo
          </button>
          <input
            #logoFileInput
            type="file"
            id="logoFile"
            name="logoFile"
            accept="image/*"
            class="d-none"
            (change)="onLogoSelected($event)"
          />
          @if (errorMessage) {
            <div class="alert alert-danger mb-3">
              {{ errorMessage }}
            </div>
          }
          <button type="submit" class="btn btn-primary auth-submit">
            {{ isEditMode ? 'Update Project' : 'Create Project' }}
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
